<template>
  <div class="message-image">
    <img
      ref="thumbnail"
      v-show="isThumbnailBlobReady"
      class="message-image__thumbnail"
      :src="thumbnailObjectUrl"
      @click="openImage"
      @load="onThumbnailLoad" />

    <chat-message-status
      v-if="isSending || !isThumbnailBlobReady"
      :style="statusStyle"
      :percentage="percentage"
      :isFinished="isFinished"
      :isFailed="isFailed"
      :statusDesc="statusDesc" />

    <div class="message-image__actions">
      <v-tooltip bottom v-if="isTeacher">
        <v-btn
          @click="addImageToWhiteboard(chatMessageDto)"
          v-show="isAttachmentReady"
          slot="activator"
          color="white"
          small
          flat
          icon>
          <v-icon>add_photo_alternate</v-icon>
        </v-btn>
        <span>加入白板</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn
          @click="saveImage(chatMessageDto)"
          v-show="isAttachmentReady"
          slot="activator"
          color="white"
          small
          flat
          icon>
          <v-icon>save_alt</v-icon>
        </v-btn>
        <span>下載</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import chatMessageMxin from './ChatMessageMixin';
import ChatMessageStatus from './ChatMessageStatus';
import SingleElementIntersectionObserver from '@/lib/single-element-intersection-observer';

export default {
  mixins: [chatMessageMxin],

  components: {
    'chat-message-status': ChatMessageStatus
  },

  data() {
    return {
      thumbnailObjectUrl: undefined
    };
  },

  props: {
    chatMessageDto: {
      type: Object,
      required: true
    }
  },

  computed: {
    statusStyle() {
      let style = {};
      style['position'] = this.isThumbnailBlobReady ? 'absolute' : 'relative';
      if (this.isThumbnailBlobReady) {
        style['background-color'] = 'rgba(0,0,0,0.4)';
        style['width'] = '100%';
        style['height'] = '100%';
        style['color'] = 'white';
      }
      return style;
    }
  },

  watch: {
    async isThumbnailBlobReady(v) {
      if (v) {
        let blob = await this.chatMessageDto.GetThumbnailAsync();
        this.thumbnailObjectUrl = URL.createObjectURL(blob);
        await this.retriveAttachment(this.chatMessageDto);
      }
    }
  },

  mounted() {
    this._oriHeight = this.$el.getBoundingClientRect().height;

    this._intersectionObserver = new SingleElementIntersectionObserver(async entry => {
      await this.retriveThumbnail(this.chatMessageDto);
    });
    this._intersectionObserver.observe(this.$el);
  },

  beforeDestroy() {
    URL.revokeObjectURL(this.thumbnailObjectUrl);
    this._intersectionObserver.disconnect();
  },

  methods: {
    openImage() {
      this.$eventBus.$emit('chat-message-open-image', this.chatMessageDto);
    },

    async retry() {
      await this.retriveThumbnail(this.chatMessageDto);
    },

    onThumbnailLoad() {
      let height = this.$el.getBoundingClientRect().height;
      this.$eventBus.$emit('chat-message-height-expand', height - this._oriHeight);
    }
  }
};
</script>

<style lang="stylus" scoped>

.message-image {
  position: relative;
  max-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover .message-image__actions {
    opacity: 1;
  }
  &:hover .message-image__thumbnail {
    filter: brightness(80%);
  }
}

.message-image__actions {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  opacity: 0;
  transition: 0.1s;
}

.message-image__thumbnail {
  cursor: pointer;
  box-shadow: $shadow-dark;
  transition: 0.2s;
}
</style>

